import React from "react";
import { graphql, QueryRenderer } from "react-relay";

import { ItemSelect, mapSelectorItemsToReactSelect } from "~/integrations/actionItemIntegration/selectors";
import { environment } from "~/models";

import type { TrelloListSelectorQuery as ListQueryType } from "~/__generated__/TrelloListSelectorQuery.graphql";

const listQuery = graphql`
	query TrelloListSelectorQuery($boardId: String!) {
		viewer {
			integrations {
				trello {
					lists(boardId: $boardId) {
						id
						name
						externalId
					}
				}
			}
		}
	}
`;

export function ListSelector({
	boardId,
	listId,
	setListId,
}: Partial<ListQueryType["variables"]> & { listId?: string; setListId: (listId: string) => void }) {
	const renderListSelector = React.useCallback(
		({ props }: { props: ListQueryType["response"] | null }) => {
			const options = mapSelectorItemsToReactSelect(props?.viewer?.integrations?.trello?.lists || []);

			return (
				<ItemSelect
					shouldAssumeDefault
					placeholder="Select a List"
					options={options}
					selectedId={listId}
					setSelectedId={setListId}
					isLoading={!props}
					isDisabled={boardId === undefined || boardId === ""}
				/>
			);
		},
		[listId, setListId, boardId],
	);

	return (
		<QueryRenderer<ListQueryType>
			environment={environment}
			query={boardId ? listQuery : null}
			variables={{ boardId: boardId ?? "" }}
			render={renderListSelector}
		/>
	);
}
